import React, { useState } from 'react';

interface YouTubeLazyProps {
  videoId: string;
  title: string;
}

const YouTubeLazy: React.FC<YouTubeLazyProps> = ({ videoId, title }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;

  return (
    <div className="relative w-full">
      <div className="pb-[56.25%]"> {/* 16:9 Aspect Ratio */}
        {!isLoaded ? (
          <button
            onClick={() => setIsLoaded(true)}
            className="absolute inset-0 w-full h-full flex items-center justify-center group"
            aria-label="Play video"
          >
            {/* Thumbnail */}
            <img
              src={thumbnailUrl}
              alt={title}
              className="absolute inset-0 w-full h-full object-cover rounded-xl"
              loading="lazy"
            />
            {/* Play Button */}
            <div className="absolute flex items-center justify-center w-16 h-16 rounded-full bg-[var(--brand-primary)]/90 group-hover:bg-[var(--brand-primary)] transition-colors">
              <svg 
                className="w-8 h-8" 
                viewBox="0 0 24 24" 
                fill="var(--text-button)"
              >
                <path d="M8 5v14l11-7z" />
              </svg>
            </div>
            {/* Optional: Add a play button hover effect */}
            <div className="absolute inset-0 bg-[var(--bg-primary)]/20 group-hover:bg-[var(--bg-primary)]/40 transition-colors rounded-xl" />
          </button>
        ) : (
          <iframe
            className="absolute inset-0 w-full h-full rounded-xl"
            src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
            title={title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        )}
      </div>
    </div>
  );
};

export default YouTubeLazy;